/** Минимальный издатель событий (связь слоя API с React без глобального состояния). */
export interface Emitter<T> {
  emit: (value: T) => void;
  subscribe: (listener: (value: T) => void) => () => void;
}

export function createEmitter<T>(): Emitter<T> {
  const listeners = new Set<(value: T) => void>();
  return {
    emit: (value) => {
      for (const listener of listeners) listener(value);
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}
